<template>
  <div>
    <ContentPage headerText="Gallery">
      <p>
        A selection of recent work — from sash window restoration to full
        exterior masonry, completed across East Anglia and Greater London:
      </p>
    </ContentPage>

    <div class="content">
      <div class="container">
        <div class="row gallery">
          <div
            v-for="image in images"
            :key="image.src"
            class="col-12 col-sm-6 col-lg-4 gallery-item"
          >
            <img
              :src="image.src"
              :alt="image.alt"
              @click="activeImage = image"
            />
          </div>
        </div>
      </div>
    </div>

    <Lightbox :image="activeImage" @close="activeImage = null" />
  </div>
</template>

<script>
import ContentPage from '@/components/partials/ContentPage.vue'
import Lightbox from '@/components/partials/Lightbox.vue'

export default {
  name: 'gallery',
  metaInfo: {
    title: 'Gallery',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'A selection of recent painting projects from Rococo Painters — sash window restoration, doors, interiors and exterior masonry across East Anglia and London.'
      }
    ]
  },
  components: {
    ContentPage,
    Lightbox
  },
  data () {
    return {
      images: [
        { src: '/images/rococo-1.jpg', alt: 'Rococo Painters project — image 1' },
        { src: '/images/Door%20restoration.png', alt: 'Door restoration' },
        { src: '/images/Interior%20design.png', alt: 'Interior design' },
        { src: '/images/Preparation.png', alt: 'Extensive preparation' },
        { src: '/images/Pre-painting.png', alt: 'Pre-painting in the workshop' },
        { src: '/images/Shutter%20restoration.png', alt: 'Shutter restoration' },
        { src: '/images/Exterior%20masonry.png', alt: 'Exterior masonry' },
        { src: '/images/rococo-2.jpg', alt: 'Rococo Painters project — image 2' },
        { src: '/images/rococo-3.jpg', alt: 'Rococo Painters project — image 3' },
        { src: '/images/rococo-4.jpg', alt: 'Rococo Painters project — image 4' },
        { src: '/images/rococo-5.jpg', alt: 'Rococo Painters project — image 5' },
        { src: '/images/rococo-6.jpg', alt: 'Rococo Painters project — image 6' }
      ],
      activeImage: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/breakpoints";
@import "../../assets/styles/variables/colors";

.content {
  padding-top: 64px;
  padding-bottom: 64px;
}

.gallery {
  row-gap: 1.5rem;

  &-item {
    img {
      width: 100%;
      height: 260px;
      object-fit: cover;
      border-radius: 8px;
      box-shadow: $shadow;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Gallery.vue